import type { UseFetchOptions } from "#app";

export function useHttp() {


    const basePath = useRuntimeConfig().public.apiUrl
    const get = async (url: string) => {
        return request('GET', url);
    }

    // Saves the response under the file name the API gives it. A user action, so $fetch rather than useFetch,
    // which is meant for loading page data.
    const download = async (url: string, accept: string) => {
        const response = await $fetch.raw(basePath + url, {headers: {...headers(), Accept: accept}, responseType: 'blob'});
        const fileName = response.headers.get('Content-Disposition')?.match(/filename="?([^";]+)"?/)?.[1];
        useUtils().saveFile(response._data, fileName);
    }

    const post = async (url: string, body: any) => {
        return request('POST', url, body);
    }

    const patch = async (url: string, body: any) => {
        return request('PATCH', url, body);
    }

    const headers = () => {
        const token = window.localStorage.getItem('token')
        return {'Accept-Language': useLanguage().lang.value, ...(token ? {Authorization: 'Bearer ' + token} : {})}
    }

    const request = async (method: 'POST' | 'GET' | 'PUT' | 'DELETE' | 'PATCH', url: string, body?: any) => {

        let options: UseFetchOptions<any> = {method: method, headers: headers()};

        if (body) {
            options = {...options, body: body}
        }


        let {data, error} = await useFetch(basePath + url, options);
        return {data, error};

    }

    return {get, download, post, patch}

}
